import "./index.css";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { ResourceLabelComponent } from "../ResourceLabelComponent";
import { useEffect, useRef, useState } from "react";
import { useTheme } from "../../contexts/ThemeContext";
import { darken, readableColor, setLightness } from "polished";
import { useMoodleV2 } from "../../contexts/moodle";
import { useParams } from "react-router-dom";

const LABEL = "label";

export const CourseContentModuleRowComponent = ({
  module,
  moodle,
  idx,
  container,
  navigating,
}) => {
  const theme = useTheme();
  const rowContainer = useRef(null);
  const [newmodules, setnewmodules] = useState(null);
  const [isCurrentModule, setCurrentModule] = useState(null);
  const [isUserVisible, setUserVisible] = useState(true);
  const [textColorByContrast, setTextColorByContrast] = useState("");
  const [maxHeight, setMaxHeight] = useState("0px");
  const contentRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [isCurrentResource, setIsCurrentResource] = useState(false);
  const moodlev2 = useMoodleV2();
  const params = useParams();

/*   useEffect(() => {
    if (isOpen) {
      setMaxHeight(`${contentRef.current.scrollHeight}px`);

    } else {
      setTimeout(() => {
        setMaxHeight(`0px`);
      }, 250);
    }
  }, [isOpen]); */

  useEffect(() => {
    if (theme) {
      /* console.log(theme) */
      setTextColorByContrast(
        readableColor(module.id === moodle.currentModuleId ? theme.colors.backgroundColorCurrentModule
            : theme.colors.backgroundColorNotCurrentModule,
          "#1a1a1a",
          "#f2f2f2",
          false
        )
      )
    }

    // eslint-disable-next-line
  }, [theme]);
  useEffect(() => {
    let filtered = module.modules.filter((res) => res.modname !== LABEL);
    setnewmodules(filtered);
    // eslint-disable-next-line
  }, [module.modules]);

  useEffect(() => {
    // console.log({ currentCourse: module });
    setUserVisible(module.uservisible);
  }, [module.uservisible]);

  useEffect(() => {
    let isCurrent = module.id === moodle.currentModuleId;
    setCurrentModule(isCurrent);
    // console.log(module)
    if (isCurrent) {
      setTimeout(() => {
        setMaxHeight(`${contentRef.current.scrollHeight}px`);
      }, 50);
      setIsOpen(true);
    } else {
      setMaxHeight(`0px`);
      setTimeout(() => {
        setIsOpen(false);
      }, 250);
    }
    const handleCurrentModule = async (isCurrent, module) => {
      if (isCurrent) {
        /* console.log("setisopen");
        setIsOpen(true); */
        /* setMaxHeight(`${contentRef.current.scrollHeight}px`); */
        await handleSummary(module);
      } else {
        console.log("setnot open");
        setMaxHeight(`0px`);
        /* setTimeout(() => {
          setIsOpen(false);
        }, 250); */
      }
    };

    //navigating > 0 && handleCurrentModule(isCurrent, module);
    // if (isCurrent) {
    //   handleScrollCurrentModule();
    // }
    // eslint-disable-next-line
  }, [/* navigating, */ moodle.currentModuleId]);

  const handleSpreed = async () => {
    if (isOpen) {
      console.log('close')
      setMaxHeight(`0px`);
      setTimeout(() => {
        setIsOpen(!isOpen);
      }, 250);
    } else {
      console.log('open')
      setTimeout(() => {
        setMaxHeight(`${contentRef.current.scrollHeight}px`);
      }, 50);
      setIsOpen(!isOpen);
    }
  };

  async function handleSummary(module) {
    if (module.summary !== "") {
      await moodle.requestPageEmbed({ pageurl: module.summary, module });
    }
  }
  useEffect(() => {
    // Check if this module contains the current resource
    if (module.modules && module.modules.length > 0 && moodle.currentResourceId) {
      const hasCurrentResource = module.modules.some(
        resource => resource.id === moodle.currentResourceId
      );
      setIsCurrentResource(hasCurrentResource);
    }
  }, [module, moodle.currentResourceId]);
  return (
    <div
      ref={rowContainer}
      className={`wrapper-row rounded-md ${isCurrentResource ? 'current-resource-container' : ''}`}
      data-module-id={module.id}
      data-contains-resource-id={isCurrentResource ? moodle.currentResourceId : ''}
      style={{
        /* backgroundColor: isCurrentModule
          ? theme.mode === "dark"
            ? "#222222"
            : "#FFCC00"
          : "#B4B4B4" */

        /* border: isCurrentModule ? "1px solid #ffffffa4" : "unset", */
        opacity: 1,
        pointerEvents: !isUserVisible ? "none" : "unset",
        display: !isUserVisible ? "none" : "block",
      }}
    >
      <div
        className="row-container rounded-t-md"
        onClick={() => handleSpreed()}
        style={{
          backgroundColor: isCurrentModule
            ? theme.colors.backgroundColorCurrentModule
            : theme.mode === "light" ?  setLightness(.9,theme.colors.backgroundColorNotCurrentModule): theme.colors.backgroundColorNotCurrentModule,
            borderLeftWidth: ".1px",
            borderRightWidth: ".1px",
            borderTopWidth: ".1px",
            borderColor: isCurrentModule ? theme.mode === "light" ?  theme.colors.backgroundColorCurrentModule: theme.colors.borderColorCurrentModule + "88": "transparent",
        }}
      >
        <div className="pl-3  flex justify-center items-center">
          <div
            className="opacity-85 rounded-md w-10 h-10 flex justify-center items-center border-opacity-15 border-[.5px] border-gray-200"
            style={{ backgroundColor: theme.colors.backgroundColorIndexRow,
            }}
            /* style={{ backgroundColor: isCurrentModule ? "#FFCC00" : "#FFCC00" }} */
          >
            <p
              className="text-2xl font-outfit font-semibold"
              style={{ color: readableColor(darken(0.09,theme.colors.backgroundColorIndexRow))}}
            >
              {idx + 1}
            </p>
          </div>
        </div>

        <div className="title-container" style={{ width: "100%" }}>
          <div
            className="title-btn font-outfit text-3xl font-medium"
            style={{
              fontSize: "15px",
              color: isCurrentModule ? textColorByContrast : theme.colors.textColorDefault,
            }}
          >
            {module.name}  
          </div>
          <div>
            {module.hasProgress && (
              <ProgressBar
                progress={module.rawProgress}
                theme={theme}
                isCurrentModule={isCurrentModule}
              />
            ) } 
            {/* <ProgressBar progress={0} theme={theme} isCurrentModule={isCurrentModule} container={{opacity:1}} />  */}
          </div>
          {module.availabilityinfo && (
            <p
              style={{ fontSize: 10, marginTop: 2, opacity: 1 }}
              dangerouslySetInnerHTML={{ __html: module.availabilityinfo }}
            ></p>
          )}
        </div>

        {newmodules && newmodules.length > 0 && (
          <div>
            {isOpen ? (
              <KeyboardArrowDownIcon sx={{ color: isCurrentModule ? textColorByContrast : theme.colors.textColorDefault, width:20, height:20}} />
            ) : (
              <KeyboardArrowRightIcon sx={{ color: isCurrentModule ? textColorByContrast : theme.colors.textColorDefault, width:20, height:20}} />
            )}
          </div>
        )}
      </div>
      <div
        ref={contentRef}
        className="module-content rounded-b-md "/*  border-opacity-15 border-gray-50 */
        style={{
          maxHeight: maxHeight,
          overflow: "hidden",
          transition: "max-height 0.5s ease",
          paddingLeft: "26px",
          borderLeftWidth:  ".1px",
          borderRightWidth:  ".1px",
          borderBottomWidth: ".1px",
          borderColor:isCurrentModule ? theme.mode === "light" ?  theme.colors.backgroundColorCurrentModule:theme.colors.borderColorCurrentModule + "88": "transparent",
          marginBottom:"1px",
          /* backgroundColor: isCurrentModule && theme.mode === "light" && theme.colors.borderColorCurrentModule, */
        }}
      >
        {isOpen &&
          newmodules &&
          newmodules.map((resource) => {
            /* console.log(resource) */
            return (
              <ResourceLabelComponent
                container={container}
                module={module}
                resource={resource}
                key={resource.id}
                moodle={moodle}
                idx={idx}
                isCurrentModule={isCurrentModule}
                isOpen={isOpen}
                setCurrentModule={setCurrentModule}
              />
            );
          })}
      </div>
    </div>
  );
};

const ProgressBar = ({ progress, theme, isCurrentModule,container }) => {
  const [ color, setColor ] = useState("");

  useEffect(() => {
    if(theme.colors){
      setColor(
        isCurrentModule
        ? readableColor(theme.colors.backgroundColorCurrentModule)
        : theme.mode === "light" ? readableColor(setLightness(0.9,theme.colors.backgroundColorNotCurrentModule)) : readableColor(setLightness(0.15,theme.colors.backgroundColorNotCurrentModule))
      );
    }
  }, [theme.colors, isCurrentModule]);

  let width = "100";
  let progressWidth = (progress * width) / 100;


  return (
    <div
      className="title-container "
      style={{
        transform: "translateY(10px)",
        width: "100%",
        ...container
      }}
    >
      <div
        style={{
          backgroundColor: "#fff",
          width: `${width}%`,
          height: 5,
          borderRadius: "5px",
        }}
      >
        <div
          style={{
            backgroundColor: theme.mode === "light" ? theme.colors.button_light : theme.colors.button_dark,
            width: `${progressWidth}%`,
            height: 5,
            borderRadius: "5px",
          }}
        ></div>
      </div>
      <span
        style={{
          color: color,
          fontSize: "10px",
          marginTop: "5px",
        }}
      >
        {progress}% completado
      </span>
    </div>
  );
};
